export default __webpack_public_path__ + "static/media/gaugeio.e71d4423.svg";